import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="footer" id="contact">
            <div className="container">
                <p>© {new Date().getFullYear()} Глаз TON'а. Актуальная ссылка - <a href="https://t.me/istoneyebot">@istoneyebot</a></p>
            </div>
        </footer>
    );
};

export default Footer;
